/* @flow weak */
import { BankAccountSelectorItem, BankAccountSelectorAddItem } from './BankAccountSelectorItem.jsx';
import ExternalAccountResourceActions from 'payments/actions/ExternalAccountResourceActions';
import ExternalAccountResourceStore from 'payments/stores/ExternalAccountResourceStore';
import LinkBankAccountModal from './LinkBankAccountModal.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import React from 'react';
import Select from 'components/Select.jsx';
import { mountModal } from 'lib/modal';

const ADD_BANK_ACCOUNT_OPTION = 'add_bank_account';

export default React.createClass({
  propTypes: {
    onSelect: React.PropTypes.func.isRequired,
    autoSelect: React.PropTypes.bool,
  },

  mixins: [
    linkStateWithStores([ExternalAccountResourceStore]),
  ],

  getDefaultProps() {
    return {
      autoSelect: true,
    };
  },

  getInitialState() {
    return this.getStateFromStores();
  },

  componentDidMount() {
    if (this.state.value) {
      const externalAccountResource = this.state.externalAccountResources.find(ea => ea.getBankAccount().id === this.state.value);
      this.props.onSelect(externalAccountResource);
    }

    if (ExternalAccountResourceStore.getExternalAccountResources().length === 0) {
      ExternalAccountResourceActions.load();
    }
  },

  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      const externalAccountResource = this.state.externalAccountResources.find(ea => ea.getBankAccount().id === this.state.value);
      this.props.onSelect(externalAccountResource);
    }
  },

  onBankAccountAdded(externalAccountResource) {
    const externalAccountResources = this.state.externalAccountResources.clone();
    externalAccountResources.add(externalAccountResource);
    this.setState({ externalAccountResources, value: externalAccountResource.getBankAccount().id });
  },

  onChange(value) {
    if (value === ADD_BANK_ACCOUNT_OPTION) {
      const modal = <LinkBankAccountModal onBankAccountAdded={this.onBankAccountAdded} />;
      mountModal(modal, this);
    }

    this.setState({ value });
  },

  getStateFromStores() {
    const externalAccountResources = ExternalAccountResourceStore.getExternalAccountResources();
    let value = this.state ? this.state.value : null;

    if (externalAccountResources.length > 0) {
      if (value === null && this.props.autoSelect) {
        value = externalAccountResources.first().getBankAccount().id;
      }
    }

    return { externalAccountResources, value };
  },

  getOptions() {
    const options = this.state.externalAccountResources.map(externalAccountResource => {
      return {
        label: externalAccountResource.getName(),
        value: externalAccountResource.getBankAccount().id,
        node: <BankAccountSelectorItem>{externalAccountResource.getName()}</BankAccountSelectorItem>,
      };
    });

    options.push({
      value: ADD_BANK_ACCOUNT_OPTION,
      label: 'Add Bank Account',
      node: <BankAccountSelectorAddItem />,
    });

    return options;
  },

  render() {
    return (
      <Select
        searchable={false}
        value={this.state.value}
        onChange={this.onChange}
        options={this.getOptions()}
      />
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/BankAccountSelector.jsx